'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiGroupOutline = function TiGroupOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 23.3c4.6 0 8.3-3.7 8.3-8.3s-3.7-8.3-8.3-8.3-8.3 3.7-8.3 8.3 3.7 8.3 8.3 8.3z m0-13.3c2.8 0 5 2.2 5 5s-2.2 5-5 5-5-2.2-5-5 2.2-5 5-5z m13.3 15c2.3 0 4.2-1.9 4.2-4.2 0-2.3-1.9-4.1-4.2-4.1-2.3 0-4.1 1.8-4.1 4.1 0 2.3 1.8 4.2 4.1 4.2z m0-6.7c1.4 0 2.5 1.2 2.5 2.5s-1.1 2.5-2.5 2.5-2.5-1.1-2.5-2.5 1.2-2.5 2.5-2.5z m0 7.7c-2.2 0-3.9 0.7-4.8 1.6-1.9-1.5-4.8-2.6-8.5-2.6-3.8 0-6.7 1.1-8.5 2.6-1-0.9-2.7-1.6-4.8-1.6-3.7 0-5.9 1.8-5.9 3.6 0 0.9 2.2 1.8 5.9 1.8 1 0 1.9 0 2.7-0.2 0 0.2-0.1 0.3-0.1 0.5 0 1.6 4 3.3 10.7 3.3 6.3 0 10.7-1.7 10.7-3.3 0-0.2 0-0.3 0-0.5 0.7 0.2 1.6 0.2 2.6 0.2 3.5 0 5.9-0.9 5.9-1.8 0-1.8-2.3-3.6-5.9-3.6z m-26.6 3.8c-2.2 0-3.5-0.4-4.1-0.6 0.4-0.7 1.7-1.6 4.1-1.6 1.8 0 3 0.6 3.6 1.2-0.1 0.2-0.2 0.4-0.3 0.6-0.8 0.2-1.9 0.4-3.3 0.4z m13.3 1.9c-3.6 0-5.8-0.6-7-1 0.9-1.1 3.2-2.4 7-2.4 3.6 0 6 1.3 6.9 2.4-1.2 0.5-3.6 1-6.9 1z m13.3-1.9c-1.5 0-2.5-0.2-3.3-0.4-0.1-0.2-0.2-0.4-0.4-0.6 0.6-0.6 1.8-1.2 3.7-1.2 2.2 0 3.6 0.9 4 1.6-0.6 0.2-2 0.6-4 0.6z m-26.6-4.8c2.3 0 4.1-1.9 4.1-4.2 0-2.3-1.8-4.1-4.1-4.1-2.3 0-4.2 1.8-4.2 4.1 0 2.3 1.9 4.2 4.2 4.2z m0-6.7c1.3 0 2.5 1.2 2.5 2.5s-1.2 2.5-2.5 2.5-2.5-1.1-2.5-2.5 1.1-2.5 2.5-2.5z' })
        )
    );
};

exports.default = TiGroupOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/group-outline.js
// module id = 3642
// module chunks = 0